module.exports = __webpack_public_path__ + "media/images/home-mobile-bf404e03b63970dc7db4ff8397583377.jpg";